let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kpSc4")).then(() => parcelRequire('89xPm'));